export type ImageExtension = string;
export const imageExtensions = [".jpg", ".png", ".webp", "original"] as const;
